module.exports = __webpack_public_path__ + "images/smart08e8113fcc59b087a4b91ea723d5639b.png";